import pickupsSaga from '~/sagas/pickups/pickups.saga';

export default pickupsSaga;
